import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-icon",
  "use": "star-icon-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" id=\"star-icon\">\n    <path d=\"M13.0818 5.1277C13.4292 4.32265 14.5708 4.32265 14.9182 5.1277L17.3374 10.7339L23.53 11.2124C24.4269 11.2817 24.7833 12.4078 24.0896 12.9806L19.4 16.8524L20.8451 22.6915C21.0579 23.5513 20.1304 24.2429 19.3671 23.7935L14 20.6339L8.63294 23.7935C7.86964 24.2429 6.94211 23.5513 7.1549 22.6915L8.6 16.8524L3.91041 12.9806C3.21666 12.4078 3.57306 11.2817 4.47005 11.2124L10.6626 10.7339L13.0818 5.1277Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol